//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      value:true,
      num:Number,
      hide:false,
      id:'',
      vhostInfo:{

      }
    }
  },
  mounted() {
    this.config()
  },
  methods:{
    async config() {
      await this.VhostConfig()
      this.VhostQuery()
    },
    async VhostConfig() {
      let data = 'cmd=free_vhost_list'
      await this.$http.post('https://api.abeiyun.com/www/vhost.php', data).then(({data}) => {
        if(data.response == 200) {
          this.num = data.num
          this.id = data.msg.id
        }
      })
    },
    async VhostQuery() {
      let data = 'cmd=vhost_query'+
        '&id='+ this.id
      await this.$http.post('https://api.abeiyun.com/www/vhost.php', data).then(({data}) => {
        if(data.response == 200) {
          this.vhostInfo = data.msg
          this.vhostInfo.domainname0 = [...data.msg.domainname.filter(item => '0' === item.id)][0].DomainName
        }
      })
    },
    vhostInit() {
      let data = 'cmd=free_vhost_init'
      this.$vux.loading.show({
        text: 'Loading'
      })
      this.$http.post('https://api.abeiyun.com/www/vhost.php', data).then(({data}) => {
        if(data.response == 200) {
          this.$vux.loading.hide()
          let _this = this
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.config()
            }
          })
        }else {
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg
          })
        }
      })
    },
    Delay() {
      this.$router.push('/user/freevhostdelay')
    },
    Domainname() {
      this.$router.push('/user/domainname/'+ this.id)
    },
    Defaultset() {
      this.$router.push('/user/defaultset/'+ this.id)
    },
    Errorpage() {
      this.$router.push('/user/errorpage/'+ this.id)
    },
    Scriptserror() {
      this.$router.push('/user/scriptserror/'+ this.id)
    },
    Redirecturl() {
      this.$router.push('/user/redirecturl/'+ this.id)
    },
    Phpselect() {
      this.$router.push('/user/phpselect/'+ this.id)
    },
    Netselect() {
      this.$router.push('/user/netselect/'+ this.id)
    },
    Preventchain() {
      this.$router.push('/user/preventchain/'+ this.id)
    },
    Gzip() {
      this.$router.push('/user/gzip/'+ this.id)
    },
    Actauth() {
      this.$router.push('/user/actauth/'+ this.id)
    },
    Dirauth() {
      this.$router.push('/user/dirauth/'+ this.id)
    },
    Blacklist() {
      this.$router.push('/user/blacklist/'+ this.id)
    },
    Restart() {
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '您确定重启主机么?',

        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          let data = 'cmd=host_reboot'+
            '&id=' + _this.id
          _this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
            if(data.response==200){
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
                onHide () {

                }
              })
            }
          })
        }
      })
    },
    ConfiemClear() {
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '您确认要清空主机内容么??',

        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          _this.$router.push('/user/clearnet/'+ _this.id)
        }
      })
    },
    Record() {
      this.$router.push('/user/vhostrecord')
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/freevhost.vue